import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(6)};

  width: 100%;
  max-width: 56rem;
  padding: ${({ theme }) => theme.spacing(6)};

  border-radius: ${({ theme }) => theme.spacing(4)};
  background: ${({ theme }) => theme.palette.common.white};
  box-shadow: ${({ theme }) => theme.shadowBox.contentBlock};
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const CardTop = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const CardFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(3)};
`;

export const Disclaimer = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.body2)};

  color: ${({ theme }) => theme.palette.text.secondary};
  text-align: center;
`;
